import React, { FC, ReactNode, useEffect, useState } from 'react';
import { FormLayout as FormLayoutCore } from 'ia-react-core';
import { NeedHelp } from 'aw-package-react-authentication';
import { getHostName } from 'omni-package-react-cms';
import { useFooterLinks } from 'omni-package-react-core';
import { getHomePageUrl, getOnCloseUrl } from '~/utils/urlUtils';
import getSitecorePath from '~/utils/getSitecorePath';
import { StyledBackground } from './FormLayout.styles';

export interface FormLayoutProps {
  children: ReactNode;
}

const FormLayout: FC<FormLayoutProps> = ({ children }) => {
  const footerUrl = getSitecorePath('global/footers/footer-non-authenticated', true, '/api/ssc/aggregate/content/Items/footer/');
  const sitecorePath = getHostName();
  interface FooterLink {
    text: string;
    url?: string;
    target?: '_blank' | '_self' | '_parent' | '_top' | undefined;
  }
  const [footerLinks, setFooterLinks] = useState<(FooterLink & { target?: string | undefined })[]>([]);
  const footerLinksFromOmniCore = useFooterLinks();
  useEffect(() => {
    if (footerLinksFromOmniCore) {
      const links: FooterLink[] = [
        ...footerLinksFromOmniCore,
      ];
      setFooterLinks(links);
    }
  }, [footerLinksFromOmniCore]);
  return (
    <>
      <FormLayoutCore
        noFooterLanguageButton={false}
        mainFooterLinksUrl={footerUrl}
        mainFooterLinksDomain={`${sitecorePath}/cw`}
        mainFooterLinks={footerLinks}
        noHeaderLanguageButton
        contentBackground="transparent"
        headerBackground="white"
        homePageUrl={getHomePageUrl()}
        onClose={() => { window.location.href = getOnCloseUrl(); }}
      >
        <FormLayoutCore.MainHeaderRightContent>
          <NeedHelp hasOnClose />
        </FormLayoutCore.MainHeaderRightContent>
        {children}
      </FormLayoutCore>
      <StyledBackground data-testid="StyledBackground" role="presentation" />
    </>
  );
};

export default FormLayout;
